export default "__VITE_ASSET__C4s6IFa0__"